export interface Video {
  id: string;
  title: string;
  category: string;
  categorySlug: string;
  thumbnail: string;
  duration: string;
  resolution: string;
  views: string;
  date: string;
  description: string;
  tags: string[];
  featured: boolean;
}

export const categories = [
  { name: '全部', slug: 'all' },
  { name: '动作大片', slug: 'action' },
  { name: '剧情精选', slug: 'drama' },
  { name: '喜剧搞笑', slug: 'comedy' },
  { name: '科幻奇幻', slug: 'scifi' },
  { name: '纪录片', slug: 'documentary' },
  { name: '动漫动画', slug: 'animation' },
  { name: '综艺娱乐', slug: 'variety' },
];

export const videos: Video[] = [
  {
    id: 'v001',
    title: '星际穿越：超越时空的旅程',
    category: '科幻奇幻',
    categorySlug: 'scifi',
    thumbnail: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20space%20scene%20with%20astronaut%20floating%20near%20a%20wormhole%2C%20cinematic%20lighting%20with%20deep%20blacks%20and%20warm%20glowing%20accents%2C%20dramatic%20composition%2C%20movie%20poster%20style%2C%20dark%20background%20with%20stars%20and%20nebula&width=640&height=360&seq=madou-video-001&orientation=landscape',
    duration: '02:48:32',
    resolution: '4K',
    views: '1280.5万',
    date: '2026-08-01',
    description: '一部震撼人心的科幻巨制，讲述人类为了寻找新家园而穿越虫洞的壮丽旅程。影片融合了尖端物理学理论与深刻的人文关怀，带领观众踏上一场超越时空的视觉盛宴。导演以宏大的叙事格局和细腻的情感刻画，打造了一部现代科幻经典。',
    tags: ['科幻', '太空', '冒险', '4K'],
    featured: true,
  },
  {
    id: 'v002',
    title: '龙虎风云：都市暗影',
    category: '动作大片',
    categorySlug: 'action',
    thumbnail: 'https://readdy.ai/api/search-image?query=Action%20movie%20scene%20with%20two%20fighters%20in%20urban%20alley%20at%20night%2C%20neon%20lights%20reflecting%20on%20wet%20pavement%2C%20cinematic%20motion%20blur%2C%20dark%20moody%20atmosphere%20with%20red%20and%20amber%20lighting%2C%20film%20grain%20texture&width=640&height=360&seq=madou-video-002&orientation=landscape',
    duration: '01:56:18',
    resolution: '1080P',
    views: '956.3万',
    date: '2026-07-28',
    description: '都市暗影下的正邪较量，两位卧底警察深入黑帮内部，展开一场惊心动魄的生死对决。高强度的打斗场面与缜密的剧情相互交织，每一帧都充满张力。实力派演员倾情演绎，打造年度最燃动作片。',
    tags: ['动作', '警匪', '悬疑', '1080P'],
    featured: true,
  },
  {
    id: 'v003',
    title: '笑傲江湖：武林外传新篇',
    category: '喜剧搞笑',
    categorySlug: 'comedy',
    thumbnail: 'https://readdy.ai/api/search-image?query=Comedy%20martial%20arts%20scene%20in%20ancient%20Chinese%20courtyard%2C%20colorful%20costumes%2C%20playful%20atmosphere%2C%20bright%20warm%20lighting%2C%20traditional%20Chinese%20architecture%20background%2C%20cinematic%20composition&width=640&height=360&seq=madou-video-003&orientation=landscape',
    duration: '01:42:05',
    resolution: '4K',
    views: '2103.7万',
    date: '2026-07-25',
    description: '经典武侠与爆笑喜剧的完美融合！一群性格迥异的武林人士在江湖中闹出无数笑话。影片以轻松幽默的笔触，重新诠释了侠义精神，让观众在捧腹大笑中感受江湖温情。',
    tags: ['喜剧', '武侠', '搞笑', '4K'],
    featured: true,
  },
  {
    id: 'v004',
    title: '深海迷踪：未知世界的探险',
    category: '纪录片',
    categorySlug: 'documentary',
    thumbnail: 'https://readdy.ai/api/search-image?query=Deep%20ocean%20documentary%20scene%20with%20bioluminescent%20creatures%20in%20dark%20blue%20water%2C%20submarine%20exploring%20coral%20reef%2C%20ethereal%20underwater%20lighting%2C%20natural%20wonder%2C%20cinematic%20wide%20shot&width=640&height=360&seq=madou-video-004&orientation=landscape',
    duration: '01:35:42',
    resolution: '4K',
    views: '687.2万',
    date: '2026-07-20',
    description: '跟随国际顶尖海洋科考团队，深入从未有人踏足的海底世界。从珊瑚礁到深海热泉，从巨型鲸鱼到微观浮游生物，4K超高清镜头记录下令人叹为观止的海洋奇观，揭示深海生态系统的奥秘。',
    tags: ['纪录片', '海洋', '自然', '4K'],
    featured: false,
  },
  {
    id: 'v005',
    title: '长安十二时辰：盛唐风云',
    category: '剧情精选',
    categorySlug: 'drama',
    thumbnail: 'https://readdy.ai/api/search-image?query=Historical%20Chinese%20drama%20scene%20set%20in%20ancient%20Changan%20city%2C%20traditional%20architecture%20with%20red%20lanterns%2C%20busy%20marketplace%2C%20warm%20golden%20hour%20lighting%2C%20Tang%20dynasty%20costumes%2C%20cinematic%20atmosphere&width=640&height=360&seq=madou-video-005&orientation=landscape',
    duration: '02:15:30',
    resolution: '4K',
    views: '1856.9万',
    date: '2026-07-15',
    description: '以盛唐时期的长安城为背景，讲述了一段惊心动魄的悬疑故事。十二个时辰内，一桩惊天阴谋即将揭开。精美的服化道还原大唐盛世风貌，紧凑的剧情让人欲罢不能。',
    tags: ['古装', '悬疑', '剧情', '4K'],
    featured: true,
  },
  {
    id: 'v006',
    title: '机甲风暴：钢铁意志',
    category: '动漫动画',
    categorySlug: 'animation',
    thumbnail: 'https://readdy.ai/api/search-image?query=Futuristic%20mecha%20anime%20scene%20with%20giant%20robot%20in%20battle%2C%20explosive%20energy%20effects%2C%20dramatic%20lighting%20with%20orange%20and%20dark%20blue%20contrast%2C%20detailed%20mechanical%20design%2C%20cinematic%20composition&width=640&height=360&seq=madou-video-006&orientation=landscape',
    duration: '01:48:20',
    resolution: '1080P',
    views: '743.5万',
    date: '2026-07-10',
    description: '未来世界，人类与巨型机甲并肩作战，对抗外星入侵者。顶级的CG动画制作，每一帧都如同艺术品。热血沸腾的战斗场面与感人至深的友情故事，让观众沉浸其中无法自拔。',
    tags: ['动漫', '机甲', '科幻', '1080P'],
    featured: false,
  },
  {
    id: 'v007',
    title: '欢乐脱口秀：笑声不断',
    category: '综艺娱乐',
    categorySlug: 'variety',
    thumbnail: 'https://readdy.ai/api/search-image?query=Stand-up%20comedy%20show%20stage%20with%20spotlight%20on%20performer%2C%20warm%20stage%20lighting%2C%20audience%20silhouettes%2C%20entertainment%20venue%20atmosphere%2C%20professional%20stage%20production%20quality&width=640&height=360&seq=madou-video-007&orientation=landscape',
    duration: '01:12:48',
    resolution: '1080P',
    views: '3201.1万',
    date: '2026-07-05',
    description: '最火爆的脱口秀综艺，汇集全国顶级段子手，用幽默解构生活。每期都有惊喜嘉宾，笑声与感动并存。轻松愉悦的观看体验，是释放压力的最佳选择。',
    tags: ['综艺', '脱口秀', '搞笑', '1080P'],
    featured: false,
  },
  {
    id: 'v008',
    title: '荒野求生：极地挑战',
    category: '纪录片',
    categorySlug: 'documentary',
    thumbnail: 'https://readdy.ai/api/search-image?query=Survival%20documentary%20in%20Arctic%20wilderness%2C%20snowy%20mountain%20landscape%2C%20person%20building%20shelter%2C%20dramatic%20natural%20light%2C%20cold%20blue%20and%20white%20tones%2C%20adventure%20photography%20style&width=640&height=360&seq=madou-video-008&orientation=landscape',
    duration: '02:05:15',
    resolution: '4K',
    views: '567.8万',
    date: '2026-06-28',
    description: '极限探险家孤身前往北极圈，在零下40度的极端环境中生存30天。4K超高清镜头记录下极地壮美风光与严酷挑战。这不仅是一部纪录片，更是对人类意志力极限的深刻探索。',
    tags: ['纪录片', '探险', '自然', '4K'],
    featured: false,
  },
  {
    id: 'v009',
    title: '夜幕追踪：城市猎人',
    category: '动作大片',
    categorySlug: 'action',
    thumbnail: 'https://readdy.ai/api/search-image?query=Noir%20action%20thriller%20scene%20on%20city%20rooftop%20at%20night%2C%20silhouette%20of%20figure%20against%20city%20skyline%2C%20dramatic%20contrast%20lighting%2C%20rain%20slicked%20surfaces%2C%20cinematic%20noir%20aesthetic&width=640&height=360&seq=madou-video-009&orientation=landscape',
    duration: '02:08:45',
    resolution: '4K',
    views: '892.4万',
    date: '2026-06-20',
    description: '夜幕降临，城市中隐藏的危险悄然浮现。一名神秘的城市猎人在摩天大楼间穿梭，追踪连环案件的真凶。高强度的跑酷动作与精彩枪战场面，配合4K高清画质，带来身临其境的观影体验。',
    tags: ['动作', '犯罪', '悬疑', '4K'],
    featured: false,
  },
  {
    id: 'v010',
    title: '奇幻森林：精灵之约',
    category: '动漫动画',
    categorySlug: 'animation',
    thumbnail: 'https://readdy.ai/api/search-image?query=Magical%20fantasy%20forest%20animation%20scene%20with%20glowing%20creatures%2C%20ethereal%20light%20rays%20through%20trees%2C%20vibrant%20colors%2C%20whimsical%20atmosphere%2C%20animated%20film%20aesthetic%20with%20soft%20magical%20glow&width=640&height=360&seq=madou-video-010&orientation=landscape',
    duration: '01:32:18',
    resolution: '1080P',
    views: '1234.6万',
    date: '2026-06-15',
    description: '一部充满想象力与温情的手绘风格动画电影。小女孩意外闯入奇幻森林，与各种精灵生物展开奇妙冒险。精美的画面、动人的音乐和温暖的故事，让每一位观众重拾童真。',
    tags: ['动漫', '奇幻', '冒险', '1080P'],
    featured: false,
  },
  {
    id: 'v011',
    title: '舌尖上的故乡：家宴记忆',
    category: '纪录片',
    categorySlug: 'documentary',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20family%20feast%20table%20with%20various%20traditional%20dishes%2C%20warm%20home%20kitchen%20atmosphere%2C%20steam%20rising%20from%20food%2C%20soft%20natural%20window%20light%2C%20cozy%20family%20dining%20scene&width=640&height=360&seq=madou-video-011&orientation=landscape',
    duration: '01:20:35',
    resolution: '4K',
    views: '2105.3万',
    date: '2026-06-08',
    description: '以家宴为线索，走访全国20个家庭，记录下最地道的中式家宴文化。从食材采购到烹饪全程，从家族故事到文化传承，4K镜头捕捉每一道菜背后的温情与记忆。',
    tags: ['纪录片', '美食', '文化', '4K'],
    featured: true,
  },
  {
    id: 'v012',
    title: '爆笑办公室：职场那些事',
    category: '喜剧搞笑',
    categorySlug: 'comedy',
    thumbnail: 'https://readdy.ai/api/search-image?query=Modern%20office%20comedy%20scene%20with%20diverse%20colleagues%20laughing%2C%20bright%20open%20workspace%2C%20natural%20daylight%2C%20casual%20creative%20atmosphere%2C%20warm%20and%20inviting%20corporate%20setting&width=640&height=360&seq=madou-video-012&orientation=landscape',
    duration: '01:45:22',
    resolution: '1080P',
    views: '1567.2万',
    date: '2026-06-01',
    description: '聚焦当代职场人的酸甜苦辣，用荒诞幽默的方式展现办公室的日常百态。每个角色都鲜活立体，笑料不断却又发人深省，是职场人必看的解压神片。',
    tags: ['喜剧', '职场', '都市', '1080P'],
    featured: false,
  },
];

export const featuredVideos = videos.filter(v => v.featured);
export const latestVideos = [...videos].sort((a, b) => b.date.localeCompare(a.date));

export const articles = [
  {
    id: 'a001',
    title: '2026年最值得期待的10部高清大片盘点',
    category: '影视资讯',
    date: '2026-08-05',
    image: 'https://readdy.ai/api/search-image?query=Cinema%20marquee%20with%20movie%20posters%20displayed%2C%20warm%20golden%20lighting%2C%20elegant%20theater%20entrance%2C%20evening%20atmosphere%2C%20entertainment%20journalism%20photography%20style&width=800&height=450&seq=madou-article-001&orientation=landscape',
    excerpt: '盘点2026年下半年最值得期待的高清大片，每一部都是视觉与故事的盛宴。',
    content: '2026年的电影市场依旧精彩纷呈，从科幻巨制到文艺佳片，各类题材百花齐放。本文为您精心挑选了10部最值得期待的高清大片，每一部都代表着当今电影工业的最高水准...',
  },
  {
    id: 'a002',
    title: '4K与1080P画质对比：你该选择哪种分辨率？',
    category: '技术科普',
    date: '2026-08-02',
    image: 'https://readdy.ai/api/search-image?query=Modern%20home%20theater%20setup%20with%20large%204K%20TV%20displaying%20vibrant%20nature%20scene%2C%20cozy%20living%20room%2C%20soft%20ambient%20lighting%2C%20tech%20lifestyle%20photography&width=800&height=450&seq=madou-article-002&orientation=landscape',
    excerpt: '详细解析4K与1080P画质的差异，帮助您根据设备和需求做出最佳选择。',
    content: '随着4K内容的普及，越来越多的观众开始关注画质选择。本文将从分辨率、码率、设备兼容性等多个维度，为您详细对比4K与1080P的实际观感差异...',
  },
  {
    id: 'a003',
    title: '麻豆cm传媒平台使用指南：畅享高清观影体验',
    category: '平台指南',
    date: '2026-07-30',
    image: 'https://readdy.ai/api/search-image?query=Modern%20streaming%20platform%20interface%20on%20laptop%20screen%2C%20clean%20minimal%20design%2C%20movie%20thumbnails%2C%20warm%20desk%20setup%2C%20cozy%20home%20environment&width=800&height=450&seq=madou-article-003&orientation=landscape',
    excerpt: '新手必读！从注册到播放，手把手教你如何玩转麻豆cm传媒平台。',
    content: '欢迎来到麻豆cm传媒在线高清平台！本指南将带您快速了解平台的核心功能与使用技巧，确保您能够获得最佳的观影体验...',
  },
  {
    id: 'a004',
    title: '国产动漫崛起：从制作到出海的华丽转身',
    category: '影视资讯',
    date: '2026-07-25',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20studio%20with%20artists%20working%20on%20digital%20tablets%2C%20colorful%20character%20designs%20on%20screens%2C%20creative%20workspace%2C%20warm%20studio%20lighting&width=800&height=450&seq=madou-article-004&orientation=landscape',
    excerpt: '中国动漫产业近年来发展迅猛，多部作品成功出海，赢得国际认可。',
    content: '从《哪吒之魔童降世》到《长安三万里》，国产动漫正在经历前所未有的黄金时代。本文深入探访多家动画工作室，揭示国产动漫崛起背后的故事...',
  },
  {
    id: 'a005',
    title: '家庭影院搭建指南：用最低预算享受高清视听',
    category: '技术科普',
    date: '2026-07-20',
    image: 'https://readdy.ai/api/search-image?query=Home%20theater%20room%20with%20projector%20and%20comfortable%20seating%2C%20warm%20ambient%20lighting%2C%20acoustic%20panels%2C%20cozy%20entertainment%20space%2C%20interior%20design%20photography&width=800&height=450&seq=madou-article-005&orientation=landscape',
    excerpt: '无需高昂预算，也能打造属于自己的私人影院，享受沉浸式观影体验。',
    content: '很多人以为搭建家庭影院需要花费数万元，其实只要掌握正确的方法，几千元就能打造出效果出色的私人影院。本文将分享从设备选购到环境布置的完整指南...',
  },
];